import { Injectable, inject } from '@angular/core';
import {
    HttpTransportType,
    HubConnection,
    HubConnectionBuilder,
    IHttpConnectionOptions,
    LogLevel,
} from '@microsoft/signalr';
import { APP_CONFIG } from '../../../env/env.token';
import { SessionData } from '../../../app/auth/models/session-data.model';
import { LocalStorageService } from '../../services/browser-storage/local-storage.service';
import { LocalStorageKeys } from '../../services/browser-storage/types/local-storage.enum';

@Injectable({ providedIn: 'root' })
export class UserOnlineTrackingHubService {
    private readonly appConfig = inject(APP_CONFIG);
    private readonly localStorage = inject(LocalStorageService);

    private readonly hubUrl = `${this.appConfig.notificationsUrl}/userOnlineTrackingHub`;

    private connection: HubConnection;

    connect(): void {
        const options: IHttpConnectionOptions = {
            transport: HttpTransportType.WebSockets,
            skipNegotiation: true,
            accessTokenFactory: () => this.localStorage.getItem<SessionData>(LocalStorageKeys.SessionData)?.accessToken,
        };

        const logLevel: LogLevel = this.appConfig.environment === 'Production' ? LogLevel.Error : LogLevel.Information;

        this.connection = new HubConnectionBuilder()
            .withUrl(this.hubUrl, options)
            .withAutomaticReconnect()
            .configureLogging(logLevel)
            .build();

        this.connection
            .start()
            .catch((err) => console.log(err));
    }

    disconnect(): void {
        this.connection?.stop();
    }
}
